import { useState, useEffect } from 'react';
import React from 'react';

const AddressStep = ({ setAddress, nextStep }) => {
    const [childAddy, setChildAddy] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [state, setState] = useState('');
    const [error, setError] = useState('');
    const [isAddressSet, setIsAddressSet] = useState(false);

    //monitor the state of the address
    
    useEffect(() => {
        if (isAddressSet) {
            nextStep();
        }
    }, [isAddressSet, nextStep]);

    const handleChangeAddress = (event) => {
        setChildAddy(event.target.value);
    };

    const handleSetZipcode = (event) => {
        setZipcode(event.target.value);
    };

    const handleSetState = (event) => {
        setState(event.target.value);
    };

    const workerAddressData = {
        address: childAddy,
        zipcode: zipcode,
        state: state
    };

    const states = ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
        "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana",
        "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
        "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
        "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma",
        "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee",
        "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin",
        "Wyoming"];

    const stateOptions = states.map((state) => (
        <option key={state} value={state}>
            {state}
        </option>
    ));

    
    const handleFinishClick = () => {
        if (!childAddy || !zipcode || !state) {
            setError('All fields are required.');
            return;
        }
        setError('');
        setAddress(workerAddressData);
        setIsAddressSet(true);
    };

    return (
        <div className='flex flex-col bg-bg p-4 rounded-xl border border-border shadow-sm w-full sm:w-1/3 mx-auto'>
            <div className='mb-4'>
                <label
                    className='block text-label font-semibold text-ink mb-1'
                    htmlFor="address">Address:</label>
                <input
                    type="text"
                    id="address"
                    value={childAddy}
                    onChange={handleChangeAddress}
                    className='w-full rounded-md border border-border px-3 py-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                    placeholder='123 Main St APT 3B'
                />
            </div>

            <div className='mb-4'>
                <label
                    className='block text-label font-semibold text-ink mb-1'
                    htmlFor="zipcode">Zip Code:</label>
                <input
                    type="text"
                    id="zipcode"
                    value={zipcode}
                    onChange={handleSetZipcode}
                    maxLength={5}
                    className='w-full rounded-md border border-border px-3 py-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                />
            </div>

            <div className='mb-4'>
                <label
                    className='block text-label font-semibold text-ink mb-1'
                    htmlFor="state">State:</label>
                <select
                    id="state"
                    value={state}
                    onChange={handleSetState}
                    className='w-full rounded-md border border-border px-3 py-2 text-body text-ink focus:outline-none focus:ring-2 focus:ring-brand/40 bg-surface'
                    size={state ? 1 : 4}
                >
                    <option value="">Select a state</option>
                    {stateOptions}
                </select>
            </div>

            {error && <p className='text-critical text-body'>{error}</p>}

            <div className='mt-4 flex justify-center'>
                <button onClick={handleFinishClick}
                    className='bg-ink text-white px-4 py-2 rounded-lg text-label font-medium hover:bg-ink-2 transition'>
                    Finish
                </button>
            </div>
        </div>
    );
};

export default AddressStep;